export const EXERCISES_PER_PAGE = 15;
export const EXERCISES_SKELETON_ON_LOADING = 15;

export const EXERCISE_CATEGORIES = [
  "machine",
  "dumbbell",
  "barbell",
  "weighted_bodyweight",
  "assisted_bodyweight",
  "reps_only",
  "cardio",
  "duration",
] as const;

export type ExerciseCategory = (typeof EXERCISE_CATEGORIES)[number];

export const PARAMETER_CATEGORIES = {
  exerciseSetup: [
    { labelKey: "series", params: ["series"] },
    { labelKey: "reps", params: ["reps", "reps_min", "reps_max"] },
    { labelKey: "duration", params: ["duration_in_seconds"] },
    { labelKey: "rest", params: ["rest_in_seconds"] },
  ],
  physiologicalTargets: [
    { labelKey: "hrTrainingZone", params: ["hr_train_min", "hr_train_max"] },
    { labelKey: "vo2Reserve", params: ["vo2_reserve_min", "vo2_reserve_max"] },
    {
      labelKey: "energyExpenditurePerExercise",
      params: [
        "min_energy_expenditure_cal_per_exercise",
        "max_energy_expenditure_cal_per_exercise",
      ],
    },
    {
      labelKey: "energyExpenditurePerMin",
      params: [
        "min_energy_expenditure_cal_per_min",
        "max_energy_expenditure_cal_per_min",
      ],
    },
  ],
  capacityAndIntensity: [
    { labelKey: "weightLifted", params: ["weight_lifted_in_grams"] },
    { labelKey: "rpe", params: ["rpe"] },
    { labelKey: "tempo", params: ["tempo"] },
  ],
} as const;

export const PARAMETER_CATEGORY_KEYS = [
  "exerciseSetup",
  "physiologicalTargets",
  "capacityAndIntensity",
] as const;

export type ParameterCategoryKey = (typeof PARAMETER_CATEGORY_KEYS)[number];
